module.exports = __webpack_public_path__ + "static/media/twinkle-fall.d2e85d7e.webm";